import React, { useState, useRef, useEffect, memo, useCallback } from 'react'
import styled from 'styled-components'
import Swiper from 'react-id-swiper'
import { useSelector } from 'react-redux'
import { Api } from '../../libs/api'
import AdSense from '../../components/adSense'

const CategoryAD = (props) => {
    const selectCategory = useSelector((state) => state.initial.selectCategory)
    const [adList, setAdList] = useState([])
    const [adLoading, setAdLoading] = useState(false)
    const [adSelect, setAdSelect] = useState(0)
    const domain = useSelector((state) => state.initial.domain)
    const swiperRef = useRef(null)
    const adCode = `${adList[adSelect]?.code_ad.toLowerCase()}`

    const params = {
        direction: 'vertical',
        slidesPerView: 5,
        spaceBetween: 0,
    }

    const getAdver = useCallback(() => {
        setAdSelect(0)
        setAdLoading(true)
        Api.getAd(domain === 'shopping' ? 'dap021' : 'dap005', selectCategory)
            .then((response) => {
                if (response.data.code === 200) {
                    let adList = response.data.result
                    if (adList) {
                        setAdList(adList)
                    } else {
                        setAdList([])
                    }
                } else {
                    setAdList([])
                }
                setAdLoading(false)
                props.setIsAdLoading(false)
                // alert('완료')
            })
            .catch((e) => {
                console.error(e)
                setAdList([])
                setAdLoading(false)
                props.setIsAdLoading(false)
                // alert('완료')
            })
        // eslint-disable-next-line
    }, [domain, selectCategory])

    const goNext = useCallback(() => {
        if (swiperRef.current && swiperRef.current.swiper) {
            swiperRef.current.swiper.slideNext()
        }
    }, [])

    const goPrev = useCallback(() => {
        if (swiperRef.current && swiperRef.current.swiper) {
            swiperRef.current.swiper.slidePrev()
        }
    }, [])

    useEffect(() => {
        getAdver()
    }, [getAdver])

    return (
        <>
            {adList.length === 1 && adList?.[0]?.idx_b_manager === '1' ? (
                <AdSense key={selectCategory} slot={2802785710} responsive={'horizontal'} margin={'0 0 50px'} />
            ) : (
                <Style>
                    <Main>
                        <a href="#!" id={`${adCode}_ad`} style={{scrollMarginTop: '100px'}}>
                            {adList.length > 0 ? (
                                <iframe
                                    src={`${process.env.REACT_APP_AD_URL}/${adCode}/all/${adList[adSelect]?.ad_id}`}
                                    title="AMD"
                                    scrolling="no"
                                ></iframe>
                            ) : (
                                adLoading
                                    ? <Loading><img src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v5/happy_loading_5.gif`} alt="" width="60" height="69" /></Loading>
                                    : <img src={`${process.env.REACT_APP_CDN_IMG}/img_ad/dap021/1/1.png`} alt="행복쇼핑" />
                            )}
                        </a>
                    </Main>
                    <Lists>
                        <Swiper {...params} ref={swiperRef}>
                            {adList.length > 0 ? (
                                adList.map((v, i) => (
                                    <div
                                        className={`item ${i === adSelect ? 'active' : ''}`}
                                        key={i}
                                        onClick={() => setAdSelect(i)}
                                    >
                                        {v.mall_name}
                                    </div>
                                ))
                            ) : (
                                <div className="item active">행복쇼핑</div>
                            )}
                        </Swiper>
                        <Buttons>
                            <button onClick={goPrev}>
                                <i className="icon-angle-up" />
                            </button>
                            <button onClick={goNext}>
                                <i className="icon-angle-down" />
                            </button>
                        </Buttons>
                    </Lists>
                </Style>
            )}
        </>
    )
}

const Style = styled.div`
    display: flex;
    border: 1px solid #e1dfeb;
    height: 236px;
    margin-bottom: 50px;
`

const Main = styled.div`
    width: 786px;
    height: 100%;
    border-right: 1px solid #e1dfeb;

    iframe {
        width: 100%;
        height: 100%;
        border: 0;
    }
`

const Lists = styled.div`
    position: relative;
    width: 162px;
    height: 210px;

    .item {
        height: 42px;
        line-height: 41px;
        border-bottom: 1px solid #e1dfeb;
        padding: 0 10px 0 20px;
        overflow: hidden;
        color: #666;
        font-size: 14px;
        font-weight: 700;
        white-space: nowrap;
        text-overflow: ellipsis;
        cursor: pointer;

        &:hover {
            color: #418ded;
        }
        &.active {
            color: #fff;
            background: #418ded;
        }
    }
`

const Buttons = styled.div`
    position: absolute;
    bottom: -24px;
    left: 0;
    width: 100%;
    display: flex;
    height: 24px;
    border-top: 1px solid #e1dfeb;

    button {
        width: 50%;
        height: 100%;
        line-height: 24px;
        border: 0;
        color: #aaa;
        font-size: 18px;

        &:first-child {
            border-right: 1px solid #e1dfeb;
        }
        &:hover {
            color: #418ded;
        }
    }
`

const Loading = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
`

export default memo(CategoryAD)



// WEBPACK FOOTER //
// ./src/estimate_list/components/banner/categoryAD.js